import { DateTime } from 'luxon';
import React, { useEffect, useState } from 'react';
import { dynamicsService } from '../services/DynamicsService';
import { AvailableTimeSlot } from '../types/DynamicsService';
type Props = {
    date: DateTime;
    selectedTimeSlot: AvailableTimeSlot | undefined;
    onSelectTimeslot: (timeSlot: AvailableTimeSlot) => void;
}
export default function Availability(props: Props): JSX.Element {
    const { date, selectedTimeSlot } = props;
    const [loading, setLoading] = useState(true);
    const [timeSlots, setTimeSlots] = useState<AvailableTimeSlot[]>();
    useEffect(() => {
        setLoading(true);
        dynamicsService.getAvailableTimeSlots(date)
            .then((timeSlots) => {
                setTimeSlots(timeSlots);
                setLoading(false);
            });
    }, [date.toISODate()]);
    return (
        <div className="elementor-widget-wrap">
            <div className="elementor-element elementor-element-96ebea2 elementor-widget elementor-widget-heading" data-id="96ebea2" data-element_type="widget" data-widget_type="heading.default">
                <div className="elementor-widget-container">
                    <h5 className="text-blue">{date.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)}</h5>
                </div>
            </div>
            <div className="elementor-element elementor-element-8e4c1d0 elementor-widget elementor-widget-heading" data-id="8e4c1d0" data-element_type="widget" data-widget_type="heading.default">
                <div className="elementor-widget-container">
                    <h6 className="text-blue">{date.toRelativeCalendar()}</h6>
                </div>
            </div>
            <div className="availability-container">
                <div className="availability">
                    {loading && <>
                        <div className="elementor-element elementor-widget" data-id="5a8c6a7" data-element_type="widget" data-widget_type="heading.default">
                            <div className="elementor-widget-container">
                                <span className="elementor-size-default text-center">Checking...</span>	<i aria-hidden="true" className="fas fa-spin fa-spinner"></i>	</div>
                        </div>
                    </>
                    }
                    {timeSlots && timeSlots.length === 0 &&
                        <i>
                            Sorry! There are no time slots available on this day. Please choose another day to schedule your assessment.
                        </i>
                    }
                    {!loading && timeSlots && timeSlots.length > 0 &&
                        <ul className="time-slot-list-items">
                            {timeSlots.map((timeSlot) => <li className="elementor-icon-list-item" key={timeSlot.id}>
                                <span className="icon-list-icon">
                                    <input type="radio" name="selectedTimeSlot" id={timeSlot.id} value={timeSlot.id} checked={timeSlot.id === selectedTimeSlot?.id} onChange={() => props.onSelectTimeslot(timeSlot)} />
                                </span>
                                <span className="elementor-icon-list-text"><label htmlFor={timeSlot.id}>{timeSlot.timeSlot}</label></span>
                            </li>
                            )}
                        </ul>
                    }
                </div>
            </div>
        </div>

    )
}